<template>
    <div class="bg-neutral-950">
        <NewHeader></NewHeader>
        <ColorBg>
            <div id="banner-top" class="relative mx-auto max-w-7xl px-6 pb-16 pt-40 sm:py-40 lg:px-8">
                <div
                    class="relative z-40 mx-auto max-w-2xl lg:mx-0 lg:grid lg:max-w-none lg:grid-cols-2 lg:gap-x-16 lg:gap-y-6 xl:grid-cols-1 xl:grid-rows-1 xl:gap-x-8 items-center">
                    <div class="mt-6 max-w-xl lg:mt-0 xl:col-end-1 xl:row-start-1">
                        <h1
                            class="font-extrabold text-5xl leading-[1.2] text-gray-200 mb-7 max-[450px]:text-3xl max-[450px]:text-center">
                            {{ t('pages.faceSwapVideo.title_prefix') }}
                            <span class="text-orange-600">{{ t('pages.faceSwapVideo.brand_name') }}</span>
                            {{ t('pages.faceSwapVideo.title_suffix') }}
                        </h1>
                        <p class="text-base font-normal text-white/50 mb-7 max-[450px]:text-center">
                            {{ t('pages.faceSwapVideo.description') }}
                        </p>
                        <div class="flex flex-col min-[450px]:flex-row items-center gap-5">
                            <FaceSwapBtn></FaceSwapBtn>
                        </div>
                    </div>
                    <img src="/idx/png_video_faceswap_header_img.png"
                        alt="Illustration of AI-powered face swapping video maker"
                        class="w-full rounded-3xl pt-12 lg:pt-0">
                </div>
            </div>
        </ColorBg>
        <!-- 2. Feature -->
        <section class="mx-auto max-w-7xl px-6 lg:px-8">
            <div
                class="mb-10 lg:mb-16 flex justify-center items-center flex-col gap-x-0 gap-y-6 lg:gap-y-0 lg:flex-row lg:justify-between max-md:max-w-lg max-md:mx-auto">
                <div class="relative w-full text-center lg:text-left lg:w-2/4">
                    <h2
                        class="text-4xl font-bold text-white leading-[3.25rem] lg:mb-6 mx-auto max-w-max lg:max-w-md lg:mx-0">
                        {{ t('pages.faceSwapVideo.benefits.title') }}</h2>
                </div>
                <div class="relative w-full text-center  lg:text-left lg:w-2/4">
                    <p class="text-lg font-normal text-white/50 mb-5">{{ t('pages.faceSwapVideo.benefits.subtitle') }}</p>
                    <div class="mt-12 w-full flex justify-center lg:justify-start">
                        <FaceSwapBtn></FaceSwapBtn>
                    </div>
                </div>
            </div>
            <div
                class="flex justify-center items-stretch gap-x-5 gap-y-8 lg:gap-y-0 flex-wrap md:flex-wrap lg:flex-nowrap lg:flex-row lg:justify-between lg:gap-x-8">
                <div
                    class="group relative w-full bg-neutral-800 rounded-2xl p-4 transition-all duration-500 max-md:max-w-md max-md:mx-auto md:w-2/5 xl:p-7 xl:w-1/4 hover:bg-orange-600 flex flex-col">
                    <div
                        class="bg-orange-100 bg-opacity-10 rounded-full flex justify-center items-center mb-5 w-14 h-14 ">
                        <img src="/idx/ic_video_feature_01.svg" alt="Icon" class="w-8 h-8">
                    </div>
                    <h4
                        class="text-xl font-semibold text-white mb-3 capitalize transition-all duration-500 group-hover:text-white">
                        {{ t('pages.faceSwapVideo.benefits.similarity.title') }}</h4>
                    <p
                        class="text-sm font-normal text-white/50 transition-all duration-500 leading-5 group-hover:text-white">
                        {{ t('pages.faceSwapVideo.benefits.similarity.description') }}
                    </p>
                </div>
                <div
                    class="group relative w-full bg-neutral-800 rounded-2xl p-4 transition-all duration-500 max-md:max-w-md max-md:mx-auto md:w-2/5 xl:p-7 xl:w-1/4 hover:bg-orange-600 flex flex-col">
                    <div
                        class="bg-orange-100 bg-opacity-10 rounded-full flex justify-center items-center mb-5 w-14 h-14 ">
                        <img src="/idx/ic_video_feature_02.svg" alt="Icon" class="w-8 h-8">
                    </div>
                    <h4
                        class="text-xl font-semibold text-white mb-3 capitalize transition-all duration-500 group-hover:text-white">
                        {{ t('pages.faceSwapVideo.benefits.hdOutput.title') }}</h4>
                    <p
                        class="text-sm font-normal text-white/50 transition-all duration-500 leading-5 group-hover:text-white">
                        {{ t('pages.faceSwapVideo.benefits.hdOutput.description') }}
                    </p>
                </div>
                <div
                    class="group relative w-full bg-neutral-800 rounded-2xl p-4 transition-all duration-500 max-md:max-w-md max-md:mx-auto md:w-2/5 xl:p-7 xl:w-1/4 hover:bg-orange-600 flex flex-col">
                    <div
                        class="bg-orange-100 bg-opacity-10 rounded-full flex justify-center items-center mb-5 w-14 h-14 ">
                        <img src="/idx/ic_video_feature_03.svg" alt="Icon" class="w-8 h-8">
                    </div>
                    <h4
                        class="text-xl font-semibold text-white mb-3 capitalize transition-all duration-500 group-hover:text-white">
                        {{ t('pages.faceSwapVideo.benefits.fastSpeed.title') }}</h4>
                    <p
                        class="text-sm font-normal text-white/50 transition-all duration-500 leading-5 group-hover:text-white">
                        {{ t('pages.faceSwapVideo.benefits.fastSpeed.description') }}
                    </p>
                </div>
                <div
                    class="group relative w-full bg-neutral-800 rounded-2xl p-4 transition-all duration-500 max-md:max-w-md max-md:mx-auto md:w-2/5 xl:p-7 xl:w-1/4 hover:bg-orange-600 flex flex-col">
                    <div
                        class="bg-orange-100 bg-opacity-10 rounded-full flex justify-center items-center mb-5 w-14 h-14 ">
                        <img src="/idx/ic_video_feature_04.svg" alt="Icon" class="w-8 h-8">
                    </div>
                    <h4
                        class="text-xl font-semibold text-white mb-3 capitalize transition-all duration-500 group-hover:text-white">
                        {{ t('pages.faceSwapVideo.benefits.noWatermark.title') }}</h4>
                    <p
                        class="text-sm font-normal text-white/50 transition-all duration-500 leading-5 group-hover:text-white">
                        {{ t('pages.faceSwapVideo.benefits.noWatermark.description') }}
                    </p>
                </div>
            </div>
        </section>
        <!-- 2. Feature END-->

        <!-- 3. Explore -->
        <section class="mx-auto max-w-7xl px-6 lg:px-8 pt-16 sm:pt-40">
            <div class="w-full flex-col justify-start items-start inline-flex">
                <div class="w-full flex-col justify-start items-center gap-3.5 flex lg:pb-12 pb-10">
                    <h2 class="text-center text-white text-4xl font-bold font-manrope leading-normal">{{ t('pages.faceSwapVideo.explore.title') }}</h2>
                    <p class="lg:max-w-4xl w-full text-center text-white/50 text-base font-normal leading-relaxed">
                        {{ t('pages.faceSwapVideo.explore.subtitle') }}</p>
                </div>
                <div class="w-full justify-start items-start gap-5 grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1">
                    <div class="w-full justify-start items-start gap-5 flex flex-col">
                        <div
                            class="w-full p-5 bg-white/5 hover:bg-white/10 rounded-2xl ring-1 ring-white/10 transition-all duration-700 ease-in-out justify-start items-start gap-3 inline-flex">
                            <div class="pt-1 justify-start items-center gap-2.5 flex">
                                <img src="/idx/ic_video_explore_01.svg" alt="Icon" class="w-6 h-6">
                            </div>
                            <div class="flex-col justify-start items-start gap-1.5 inline-flex">
                                <h3 class="text-white text-lg font-medium leading-relaxed">{{ t('pages.faceSwapVideo.explore.swapOwnVideos.title') }}
                                </h3>
                                <p class="text-white/50 text-sm font-normal leading-snug">{{ t('pages.faceSwapVideo.explore.swapOwnVideos.description') }}</p>
                            </div>
                        </div>
                        <div
                            class="w-full p-5 bg-white/5 hover:bg-white/10 rounded-2xl ring-1 ring-white/10 transition-all duration-700 ease-in-out flex-col justify-start items-start gap-5 flex">
                            <div class="justify-start items-start gap-3 inline-flex">
                                <div class="pt-1 justify-start items-center gap-2.5 flex">
                                    <div class="w-[22px] h-[22px] justify-center items-center flex">
                                        <img src="/idx/ic_video_explore_02.svg" alt="Icon" class="w-6 h-6">

                                    </div>
                                </div>
                                <div class="flex-col justify-start items-start gap-1.5 inline-flex">
                                    <h3 class="text-white text-lg font-medium leading-relaxed">{{ t('pages.faceSwapVideo.explore.movieScenes.title') }}
                                    </h3>
                                    <p class="text-white/50 text-sm font-normal leading-snug">{{ t('pages.faceSwapVideo.explore.movieScenes.description') }}</p>
                                </div>
                            </div>
                            <img class="w-full aspect-[3/2] rounded-lg object-cover" src="/idx/png_video_explore_01.jpg"
                                alt="Example of AI face swap placing user in iconic movie scene" />
                        </div>
                    </div>
                    <div class="w-full justify-start items-start gap-5 flex flex-col">
                        <div
                            class="w-full p-5 bg-white/5 hover:bg-white/10 rounded-2xl ring-1 ring-white/10 transition-all duration-700 ease-in-out flex-col justify-start items-start gap-5 flex">
                            <div class="justify-start items-start gap-3 inline-flex">
                                <div class="pt-1 justify-start items-center gap-2.5 flex">
                                    <div class="w-[22px] h-[22px] relative">
                                        <img src="/idx/ic_video_explore_03.svg" alt="Icon" class="w-6 h-6">
                                    </div>
                                </div>
                                <div class="flex-col justify-start items-start gap-1.5 inline-flex">
                                    <h3 class="text-white text-lg font-medium leading-relaxed">{{ t('pages.faceSwapVideo.explore.hairstylesOutfits.title') }}</h3>
                                    <p class="text-white/50 text-sm font-normal leading-snug">{{ t('pages.faceSwapVideo.explore.hairstylesOutfits.description') }}</p>
                                </div>
                            </div>
                            <img class="w-full aspect-[3/2] rounded-lg object-cover" src="/idx/png_video_explore_02.jpg"
                                alt="Example of AI face swap for trying new hairstyles and outfits" />
                        </div>
                        <div
                            class="w-full p-5 bg-white/5 hover:bg-white/10 rounded-2xl ring-1 ring-white/10 transition-all duration-700 ease-in-out justify-start items-start gap-3 inline-flex">
                            <div class="pt-1 justify-start items-center gap-2.5 flex">
                                <div class="w-[22px] h-[22px] relative">
                                    <img src="/idx/ic_video_explore_04.svg" alt="Icon" class="w-6 h-6">

                                </div>
                            </div>
                            <div class="flex-col justify-start items-start gap-1.5 inline-flex">
                                <h3 class="text-white text-lg font-medium leading-relaxed">{{ t('pages.faceSwapVideo.explore.memes.title') }}
                                </h3>
                                <p class="text-white/50 text-sm font-normal leading-snug">{{ t('pages.faceSwapVideo.explore.memes.description') }}</p>
                            </div>
                        </div>
                    </div>
                    <div class="w-full justify-start items-start gap-5 flex flex-col">
                        <div
                            class="w-full p-5 bg-white/5 hover:bg-white/10 rounded-2xl ring-1 ring-white/10 transition-all duration-700 ease-in-out justify-start items-start gap-2.5 inline-flex">
                            <div class="pt-1 justify-start items-center gap-2.5 flex">
                                <div class="w-[22px] h-[22px] relative">
                                    <img src="/idx/ic_video_explore_05.svg" alt="Icon" class="w-6 h-6">

                                </div>
                            </div>
                            <div class="flex-col justify-start items-start gap-1.5 inline-flex">
                                <h3 class="text-white text-lg font-medium leading-relaxed">{{ t('pages.faceSwapVideo.explore.friendFamily.title') }}
                                </h3>
                                <p class="text-white/50 text-sm font-normal leading-snug break-all">{{ t('pages.faceSwapVideo.explore.friendFamily.description') }}</p>
                            </div>
                        </div>
                        <div
                            class="w-full p-5 bg-white/5 hover:bg-white/10 rounded-2xl ring-1 ring-white/10 transition-all duration-700 ease-in-out flex-col justify-start items-start gap-5 flex">
                            <div class="justify-start items-start gap-3 inline-flex">
                                <div class="pt-1 justify-start items-center gap-2.5 flex">
                                    <div class="w-[22px] h-[22px] relative">
                                        <img src="/idx/ic_video_explore_06.svg" alt="Icon" class="w-6 h-6">
                                    </div>
                                </div>
                                <div class="flex-col justify-start items-start gap-1.5 inline-flex">
                                    <h3 class="text-white text-lg font-medium leading-relaxed">{{ t('pages.faceSwapVideo.explore.socialMedia.title') }}</h3>
                                    <p class="text-white/50 text-sm font-normal leading-snug">{{ t('pages.faceSwapVideo.explore.socialMedia.description') }}</p>
                                </div>
                            </div>
                            <img class="w-full aspect-[3/2] rounded-lg object-cover" src="/idx/png_video_explore_03.jpg"
                                alt="Example of using AI face swap to boost social media presence" />
                        </div>
                    </div>
                </div>
            </div>
            <div class="mt-12 w-full flex justify-center">
                <FaceSwapBtn></FaceSwapBtn>
            </div>
        </section>
        <!-- 3. Explore END -->

        <Testimonial :items="items"></Testimonial>
        <Cta></Cta>
        <NewFooter class="!absolute z-50"></NewFooter>
    </div>
</template>
<script setup lang="ts">
import NewHeader from '~/components/NewHeader.vue';
import NewFooter from '~/components/NewFooter.vue';
import FaceSwapBtn from '~/components/FaceSwapBtn.vue';
import Cta from '~/components/Cta.vue';
import Testimonial from '~/components/Testimonial.vue';
import ColorBg from '~/components/ColorBg.vue';

const { t } = useI18n();

useHead({
    title: t('seo.faceSwapVideo.title'),
    meta: [
        {
            name: 'description',
            content: t('seo.faceSwapVideo.description')
        }
    ],
});

const items = [
    {
        avatar: '/idx/avater_01.png',
        name: t('pages.faceSwapVideo.testimonials.person1.name'),
        content: t('pages.faceSwapVideo.testimonials.person1.content')
    },
    {
        avatar: '/idx/avater_02.png',
        name: t('pages.faceSwapVideo.testimonials.person2.name'),
        content: t('pages.faceSwapVideo.testimonials.person2.content')
    },
    {
        avatar: '/idx/avater_03.png',
        name: t('pages.faceSwapVideo.testimonials.person3.name'),
        content: t('pages.faceSwapVideo.testimonials.person3.content')
    },
    {
        avatar: '/idx/avater_04.png',
        name: t('pages.faceSwapVideo.testimonials.person4.name'),
        content: t('pages.faceSwapVideo.testimonials.person4.content')
    },
    {
        avatar: '/idx/avater_05.png',
        name: t('pages.faceSwapVideo.testimonials.person5.name'),
        content: t('pages.faceSwapVideo.testimonials.person5.content')
    },
    {
        avatar: '/idx/avater_06.png',
        name: t('pages.faceSwapVideo.testimonials.person6.name'),
        content: t('pages.faceSwapVideo.testimonials.person6.content')
    }
];
</script>